<template>
  <div class="pa-5">
    <v-card shaped class="elevation-10" v-if="documents && documents.data">
      <v-card-title>
        <div>รายการเอกสาร</div>
        <v-spacer></v-spacer>
        <v-btn color="success" to="/document/create">เพิ่มเอกสาร</v-btn>
      </v-card-title>
      <v-card-text class="py-0">
        <v-row>
          <v-col md="6">
            <v-select 
              dense 
              solo 
              :items="document_types" 
              item-text="name_th" 
              item-value="id" 
              label="ประเภทเอกสาร"
              @change="type_change"
            ></v-select>
          </v-col>
          <v-col md="6">
            <v-text-field v-model="term" dense solo prepend-inner-icon="mdi-magnify" label="ค้นหา" @input="searchChange"></v-text-field>
          </v-col>
        </v-row>    
      </v-card-text>
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th style="width: 15%;">ประเภท</th>
              <th style="width: 65%;">ชื่อเอกสาร</th>
              <th style="width: 15%;">สถานะ</th>
              <th style="width: 5%;"></th>
            </tr>
          </thead>
          <tbody v-if="documents.data.length > 0">
            <tr v-for="item in documents.data" :key="item.id">
              <td class="text-truncate">{{ item.document_type.name_th }}</td>
              <td>{{ item.name_th }}</td>
              <td>
                <v-chip tile v-if="item.status == 0">ไม่ระบุ</v-chip>
                <v-chip tile v-if="item.status == 1" color="success">บังคับใช้</v-chip>
                <v-chip tile v-if="item.status == 2" color="error">ยกเลิก</v-chip>
              </td>
              <td>
                <v-menu offset-y transition="fade-transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-on="on" v-bind="attrs"><v-icon>mdi-dots-vertical</v-icon></v-btn>
                  </template>
                  <v-list>
                    <v-list-item :to="`/document/${item.id}/edit`">
                      <v-list-item-icon><v-icon>mdi-pencil</v-icon></v-list-item-icon>
                      <v-list-item-title>แก้ไข</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="confirmDeleteDocument(item.id)">
                      <v-list-item-icon><v-icon>mdi-delete</v-icon></v-list-item-icon>
                      <v-list-item-title>ลบ</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <v-subheader>---ไม่พบเอกสารในระบบ---</v-subheader>
          </tbody>
        </template>
      </v-simple-table>
      <v-pagination
        class="pb-5"
        v-model="page"
        :length="documents.last_page"
        @input="selectPage"
      ></v-pagination>
    </v-card>
    <v-dialog v-model="confirm_delete" max-width="500">
      <v-card>
        <v-card-title>ยืนยันการลบเอกสาร</v-card-title>
        <v-card-text>คุณต้องการลบเอกสารนี้ใช่หรือไม่</v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="deleteDocument()">ยืนยัน</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  data: () => ({
    page: 1,
    term: '',
    type: '',
    documents: null,
    confirm_delete: false
  }),
  computed: {
    document_types() { 
      return [ { id: '', name_th: 'ทั้งหมด' }, ...this.$store.state.document.document_types ]
    }
  },
  created() {
    this.getDocument('', '', this.page);
  },
  methods: {
    getDocument(term, type, page) {
      this.$store.dispatch('document/list', {
        term: term,
        type: type,
        page: page
      }).then(data => this.documents = data);
    },
    deleteDocument() {
      this.$store.dispatch('document/delete', this.delete_selected).then(() => {
        this.getDocument('', '', 1);
        this.confirm_delete = false;
        this.$store.commit('SHOW_SNACKBAR', {
          color: 'success',
          message: 'ลบข้อมูลสำเร็จ'
        });
      });
    },
    confirmDeleteDocument(id) {
      this.confirm_delete = true;
      this.delete_selected = id;
    },
    selectPage(e) {
      this.page = e;
      this.getDocument(this.term, this.type, e);
    },
    type_change(val) {
      this.type = val;
      this.getDocument(this.term, val, 1);
    },
    searchChange: _.debounce(function(e) {
      this.page = 1;
			this.getDocument(e, this.type, 1);
		}, 500),
  }
}
</script>